var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7615 39.4242C25.2015 39.4242 24.6532 39.2842 24.1398 39.0042C23.1132 38.4326 22.4948 37.3942 22.4948 36.2276V30.0442C22.4948 29.4609 22.1098 28.5859 21.7482 28.1426L17.3848 23.5226C16.6498 22.7876 16.0898 21.5276 16.0898 20.5826V17.8992C16.0898 16.0326 17.5015 14.5742 19.2982 14.5742H34.6982C36.4715 14.5742 37.9065 16.0092 37.9065 17.7826V20.3492C37.9065 21.5742 37.1715 22.9626 36.4832 23.6509L31.4315 28.1192C30.9415 28.5276 30.5565 29.4259 30.5565 30.1492V35.1659C30.5565 36.2042 29.9032 37.4059 29.0865 37.8959L27.4765 38.9342C26.9515 39.2609 26.3565 39.4242 25.7615 39.4242ZM19.2982 16.3242C18.4815 16.3242 17.8398 17.0126 17.8398 17.8992V20.5826C17.8398 21.0142 18.1898 21.8542 18.6332 22.2976L23.0782 26.9759C23.6732 27.7109 24.2565 28.9359 24.2565 30.0326V36.2159C24.2565 36.9742 24.7815 37.3475 25.0032 37.4642C25.4932 37.7325 26.0882 37.7325 26.5432 37.4525L28.1648 36.4142C28.4915 36.2159 28.8182 35.5859 28.8182 35.1659V30.1492C28.8182 28.9009 29.4248 27.5242 30.2998 26.7892L35.2932 22.3676C35.6898 21.9709 36.1682 21.0259 36.1682 20.3376V17.7826C36.1682 16.9776 35.5148 16.3242 34.7098 16.3242H19.2982Z",
    fill: "#38879F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 25.5412C19.8369 25.5412 19.6853 25.4945 19.5336 25.4128C19.1253 25.1562 18.9969 24.6078 19.2536 24.1995L25.0053 14.9828C25.2619 14.5745 25.7986 14.4462 26.2069 14.7028C26.6153 14.9595 26.7436 15.4962 26.4869 15.9045L20.7353 25.1212C20.5719 25.3895 20.2919 25.5412 20.0003 25.5412Z",
    fill: "#38879F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ad5b1d71dff32bd2a60f387f78f8c639.svg";
export { ForwardRef as ReactComponent };